"use client";

import { SessionProvider } from "next-auth/react";

/**
 * Client-side session for the public site.
 *
 * The root layout must not read the session on the server (`auth()` reads the
 * request cookies, which makes EVERY route dynamic and uncacheable). Components
 * that need to know who is signed in (Header, MobileMenu, reviews, code modal)
 * read it here with `useSession()` instead; it is fetched once per page load from
 * /api/auth/session. Anonymous visitors, and the cached HTML, render the
 * signed-out UI.
 */
export default function AuthProvider({ children }: { children: React.ReactNode }) {
    return <SessionProvider refetchOnWindowFocus={false}>{children}</SessionProvider>;
}
